import { apiSlice } from "@app/api/apiSlice";

export const smsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllSms: builder.mutation({
      query: (query) => ({
        url: `sms/admin?${query}`,
      }),
    }),
  }),
});

export const { useLoadAllSmsMutation } = smsApiSlice;
